import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { BiSolidDownload } from "react-icons/bi";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';



import './Header.css';

function Header({ 
  maintenanceCycles, 
  selectedCycle, 
  setSelectedCycle, 
  selectedMaintenance, 
  isRegional = false,
  isCorporate = false,
  contractLabel = '',
  hideMaintenanceCycle = false,
  onRequestEmergency,
  reportFieldName = 'finalReport',
  valveAuditMode = false,
}) {
  const [finalReportUrl, setFinalReportUrl] = useState('');

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Download PDF report for selected maintenance cycle
    </Tooltip>
  );

  // Ensure the finalReportUrl updates when selectedMaintenance changes
  // Use the specified reportFieldName (finalReport or dryerReport)
  useEffect(() => {
    const reportField = selectedMaintenance?.[reportFieldName];
    if (reportField) {
      // Handle both file object format {url: "..."} and direct URL string
      const url = typeof reportField === 'string' ? reportField : (reportField.url || '');
      setFinalReportUrl(url);
    } else {
      setFinalReportUrl('');
    }
  }, [selectedMaintenance, reportFieldName]);

  const userStr = localStorage.getItem('managerUser');
  let firstName = "";
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      firstName = user.first_name || "";
    } catch (err) {
      console.error("Error parsing user data:", err);
    }
  }

  console.log("Final Report URL in Header:", finalReportUrl); // Debugging line

  return (
    <div className="header-wrapper manager-cycle-header">
      <div className="header-inner">
        <Row className="align-items-center">
          <Col md={6}>
            <h5 className="welcome-text">
              <span className="welcome-highlight">Hi {firstName},</span> welcome back!
            </h5>
            {hideMaintenanceCycle && !valveAuditMode && (
              <div className="d-md-none mt-2">
                <Button
                  variant="primary"
                  onClick={onRequestEmergency}
                  size="sm"
                  style={{ backgroundColor: '#2c59a2', borderColor: '#2c59a2' }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#1e40af';
                    e.target.style.borderColor = '#1e40af';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#2c59a2';
                    e.target.style.borderColor = '#2c59a2';
                  }}
                >
                  Request Service Visit
                </Button>
              </div>
            )}
            {valveAuditMode && (
              <div className="d-md-none mt-2" style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <img src="https://parsefiles.back4app.com/JPeNcGnGVRxgfjR3k0WTs3fbP6Vu4AagMGFXanwd/5f6dc93d4cadf6e8cfdff9712c07aaa6_bmi-logo.png" alt="BMI" style={{ height: 52, objectFit: 'contain', flexShrink: 0, marginTop: -8, marginBottom: -8 }} />
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '0.78rem', color: '#64748b', fontWeight: 600, lineHeight: 1.2 }}>Project completed by BMI</div>
                  <div style={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 500, lineHeight: 1.2 }}>Dashboard powered by Hudson</div>
                </div>
              </div>
            )}
          </Col>

          {!isRegional && !isCorporate && (
            <Col
              md={6}
              className="manager-cycle-controls text-md-end d-flex align-items-center justify-content-md-end mt-3 mt-md-0"
              data-tour="maintenance-filter"
            >
              {valveAuditMode ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', justifyContent: 'flex-end' }}>
                  <img
                    src="https://parsefiles.back4app.com/JPeNcGnGVRxgfjR3k0WTs3fbP6Vu4AagMGFXanwd/5f6dc93d4cadf6e8cfdff9712c07aaa6_bmi-logo.png"
                    alt="BMI Plumbing & HVAC"
                    style={{ height: 60, objectFit: 'contain', borderRadius: 4, flexShrink: 0, marginTop: -10, marginBottom: -10 }}
                  />
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '0.85rem', color: '#475569', fontWeight: 700, lineHeight: 1.2 }}>Project completed by BMI</div>
                    <div style={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 500, lineHeight: 1.2 }}>Dashboard powered by Hudson</div>
                  </div>
                </div>
              ) : hideMaintenanceCycle ? (
                <Button
                  variant="primary"
                  onClick={onRequestEmergency}
                  style={{ marginLeft: '1rem', backgroundColor: '#2c59a2', borderColor: '#2c59a2' }}
                  className="d-none d-md-inline-block"
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#1e40af';
                    e.target.style.borderColor = '#1e40af';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#2c59a2';
                    e.target.style.borderColor = '#2c59a2';
                  }}
                >
                  Request Service Visit
                </Button>
              ) : (
                <>
                  <Form.Label htmlFor="manager-maintenance-cycle" className="me-2 mb-0 fw-bold">Maintenance Cycle:</Form.Label>
                  <Form.Select
                    id="manager-maintenance-cycle"
                    className="header-date-input"
                    value={selectedCycle}
                    onChange={(e) => setSelectedCycle(e.target.value)}
                  >
                    {maintenanceCycles.length === 0 ? (
                      <option value="">No cycles found</option>
                    ) : (
                      maintenanceCycles.map((item) => (
                        <option key={item.objectId} value={item.cycle}>
                          {item.cycle}
                        </option>
                      ))
                    )}
                  </Form.Select>

                  {/* Download Button */}
                  {finalReportUrl ? (
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Button
                      variant="link"
                      href={finalReportUrl}
                      target="_blank"
                      style={{ color: '#2c59a2', textDecoration: 'none', marginLeft: '1rem' }}
                      data-tour="download-report"
                      aria-label="Download maintenance report"
                      className="manager-report-download"
                    >
                      <BiSolidDownload
                      style={{ fontSize: '1.5rem', marginRight: '0.25rem' }} />
                    </Button>
                    </OverlayTrigger>
                  ) : (
                    <span style={{ color: 'lightgray', marginLeft: '1rem' }}></span>
                  )}
                </>
              )}
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
}

export default Header;
